import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import FilterSectionLegacy from './_do_not_import_/FilterSection';
import FilterSectionV2, { IFilterSectionProps } from './_do_not_import_v2_/FilterSection';

export const FilterSection = (props: IFilterSectionProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <FilterSectionV2 {...props} />;
  }

  return <FilterSectionLegacy {...props} />;
};
